import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm, SubmissionError } from 'redux-form';
import { FormGroup, FormControl, HelpBlock } from 'react-bootstrap';
import Fa from 'react-fontawesome';
import styles from './styles.css';

// Import Selectors
import { getLoginErrors } from '../../AuthReducer';
import { loginWithEmailAndPassword } from '../../AuthActions';

class AuthenticatePage extends Component {
  constructor() {
    super();
    this.state = {
      error: null,
      openFields: true,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.renderField = this.renderField.bind(this);
    this.buttonOpenFields = this.buttonOpenFields.bind(this);
  }

  handleSubmit(data) {
    const { valid } = this.props;
    if (!valid) {
      return Promise.reject();
    }
    this.props.onLoading(true);
    this.setState({ error:  null });
    return new Promise((resolve, reject) => {
      const p = this.props.dispatch(loginWithEmailAndPassword(data.username, data.password));
      p.then(
        (user) => {
          this.props.onSuccess(user);
          this.props.onLoading(false);
          resolve(user);
        },
        (errors) => {
          const e = errors.data || errors;
          if (e.message) {
            e._error = e.message;
            e.username = e.message;
            this.setState({ error:  e.message, openFields: false });
            this.props.hideForgot(true);
          }
          this.props.onLoading(false);
          reject(e);
          throw new SubmissionError(e);
        },
      );
    });
  }

  buttonOpenFields() {
    this.setState({ openFields: true });
    this.props.hideForgot(false);
  }

  renderField({
    input, label, type, meta: { touched, error },
  }) {
    const validationState = touched && error ? 'error' : null;
    return (
      <FormGroup validationState={validationState}>
        <FormControl {...input} placeholder={label} type={type} />
        <FormControl.Feedback />
        {touched && error && <HelpBlock className="text-left">{error}</HelpBlock>}
      </FormGroup>
    );
  }

  render() {
    const { handleSubmit, submitting, isDark } = this.props;
    const { error, openFields } = this.state;
    return (
      <div>
        <form method="post" action="/api/login" onSubmit={handleSubmit(this.handleSubmit)}>
          {error !== null && !openFields && 
            <div className={`${isDark ? styles.warningNight : styles.warning} ${styles.warningPanel} animated fadeIn`}>
              <Fa name="exclamation-triangle fa-3x" />
              <div className={`${styles.warningText}`}>
              <div className={`${styles.warningBold}`}>User validation failed.</div><div>{error}</div>
              </div>
              <span className={`pull-right ${isDark ? styles.retryBtnNight : styles.retryBtn}`} onClick={this.buttonOpenFields}>RETRY</span>
            </div>
          }
          {openFields && <div className={`animated ${openFields ? "fadeIn" : "fadeOut"}`}>
          <Field disabled={submitting} name="username" type="text" component={this.renderField} label="Username" />
          <Field disabled={submitting} name="password" type="password" component={this.renderField} label="Password" />
          <br />
          <button type="submit" disabled={submitting} className="btn btn-primary btn-lg btn-block">
            Login
          </button>
          </div>}
        </form>
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    errors: getLoginErrors(state),
  };
}

AuthenticatePage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  valid: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  onLoading: PropTypes.func,
  onSuccess: PropTypes.func,
  errors: PropTypes.object.isRequired,
  error: PropTypes.string,
  location: PropTypes.object.isRequired,
  isDark: PropTypes.bool,
};
AuthenticatePage.defaultProps = {
  onLoading: () => {},
  onSuccess: () => {},
  error: null,
  isDark: false,
};

AuthenticatePage.contextTypes = {
  router: PropTypes.object,
};

const validate = (values) => {
  const errors = {};
  if (!values.username) {
    errors.username = 'Username is required';
  }
  if (!values.password) {
    errors.password = 'Password is required';
  }
  return errors;
};


const AuthenticateForm = reduxForm({
  form: 'authenticateForm',
  validate,
})(AuthenticatePage);

export default connect(mapStateToProps)(AuthenticateForm);
